import React from "react";


export default function TermsAndServices () {
    return(
        <div>TermsAndServices</div>
    )
}